import Vue from "vue";

export default {
  /**
   * 获取rtc房间的授权码
   *
   * @param {
   *   yk_user_token:string 用户在优课场域的token，如果用户身份是X时可以不传
   *   req_class_id_code:string 课堂ID码，必传
   *   req_scence:string 请求的场景，必传。PA：加入活动，CA：创建活动
   *   user_type:string 用户类型，必传。 学生：S，教师：T，非登录人员：X
   *   gid:string 园区ID，必传
   * } params 入参对象
   * @param {*} config
   */
  async getRtcToken(params = {}, config = {}) {
    config.params = params
    let result = await Vue.http.get("/aliyun-rtc/get-token", config)
    return result
  }
}
